import { createNamespaceWebSocketContext } from 'src/context/createNamespaceWebSocketContext';
import { createEmptyWebSocketContext } from 'src/context/createEmptyWebSocketContext';
import { SOCKET } from 'src/constants';

export const {
  NamespaceWebSocketProvider: ScheduledMessagesWebSocketProvider,
  useNamespaceWebSocket: useScheduledMessagesWebSocket,
} = !SOCKET?.TURN_OFF_SOCKETS_ON_THE_SCHEDULED_CONNECTIONS_PAGE
  ? createNamespaceWebSocketContext('/scheduled_messages', false)
  : createEmptyWebSocketContext();
